import { render, staticRenderFns } from "./kick_from_team.vue?vue&type=template&id=40f9ebae"
import script from "./kick_from_team.vue?vue&type=script&lang=ts"
export * from "./kick_from_team.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports